import {AudioParamValueParameter} from './AbstractAudioParamParameter.js';
import Tone from 'tone';
class PolyParameter extends AudioParamValueParameter {
    constructor(name, audioParams, config={}, rampTime=0.1) {
        super(name, new Tone.Signal(0), config, rampTime);
        if (audioParams) {
            this.setAudioParams(audioParams);
        }
    }


    set(x, automation=true, isBulk=false, time, rampTime=0.040) {
        let ret = super.set(x,automation, isBulk, time, rampTime);

        if (this._audioParams && (this.keyScaling || !automation)) {
            // need to set all the underlying params back to 0
            // TODO: check if any of the underlying parameters
            // were messed with before doing this. This
            // will make it more efficient
            this._audioParams.filter(
                p => p.input)
                .forEach(
                param => param.value = 0);
        }
        return ret;
    }

    disableKeyScaling() {
        this.set(this.get(true), true, true);
        this.keyScaling = undefined;
        this._audioParams.filter(
            p => p.input)
            .forEach(
                param => param.value = 0);
    }

    setAudioParams(audioParams) {
        // we dont want to connect undefined params
        // we don't want to reconnect audio params that are already connected
        audioParams = audioParams.filter(x => x);
        
        audioParams
            .filter(a => !this._audioParams || !this._audioParams.includes(a))
            .forEach(
                a => this.audioParam.connect(a));
        this._audioParams = audioParams;
    }

    removeAudioParams(params) {
        params.forEach(p => this.removeAudioParam(p));
    }

    removeAudioParam(audioParam) {
        if (!audioParam || !this._audioParams.includes(audioParam)) {
            console.log("Failed to remove audio param for %s", this.name, audioParam, this._audioParams);
            return;
        }
        this._audioParams = this._audioParams.filter(
            s => s !== audioParam);

        if (audioParam.input && this.audioParam) {
            this.audioParam.disconnect(audioParam);
            audioParam.value = 0;
        }
    }
    
}


window.findBadPoly = () => window.sequencerEngine.tracks[0].getAllParameters().filter(x => !x.name.includes("Formant")).filter(
    x => x._audioParams).filter(
        x => x._audioParams.some(x => !x.input || x.value !== 0)).map(x => [x.name, x._audioParams.map(x => x.input && x.value)]);



export default PolyParameter;
